/**
 * Siltcon Auréa: keuzehulp (popup). Hoort bij snippets/aurea-keuzehulp.liquid.
 *
 * - Opent nooit vanzelf. Alleen via een link naar #keuzehulp of via ?keuzehulp=1 in de url.
 * - Zeven vragen, een per scherm. Vraag 7 (Strava) alleen als vraag 6 Ja of Soms is. Terug kan vanaf vraag 2.
 * - De voortgangsbalk telt alleen de vragen.
 * - GPS-wens: vraag 6 Ja, of Strava Ja, of (vraag 5 "Mijn route bijhouden" en vraag 6 Soms).
 * - Match, in deze volgorde, de eerste die past wint:
 *   1. GPS-wens: Auréa 2.
 *   2. Look Vierkant: Seréa.
 *   3. Kleur Champagne: Auréa 2.
 *   4. Look Rond: Auréa of Auréa 2 op punten. Smal Auréa +3, Stijl Auréa +1, Sport Auréa 2 +2, Allebei Auréa 2 +1.
 *   5. Look Maakt niet uit: alle drie op punten. Smal Auréa +3, Breed Seréa +3, Stijl Auréa +1 en Seréa +1,
 *      Sport Auréa 2 +2, Allebei Auréa 2 +1.
 *   Bij 4 en 5: Zilver of Zwart laat Auréa 2 afvallen. Gelijkspel: Auréa, dan Seréa, dan Auréa 2.
 * - Kleur: de gekozen kleur als het model die heeft, anders Goud.
 * - Redenen (2 of 3) en extra zinnen: zie bepaalRedenen en bepaalExtra.
 * - Foto, naam, link en variant-id komen uit [data-kh-data] in de snippet (optie Kleur van het product).
 * - Bij sluiten gaat, zoals eerder, het event 'aurea:keuzehulp-gesloten' uit en wordt aurea_kh_gesloten_op bewaard.
 * - Voor tests: root.aureaKhBereken(antwoorden) geeft { model, kleur, redenen, extra } zonder de popup te tonen.
 */
(() => {
  const root = document.querySelector('[data-aurea-kh]');
  if (!root) return;

  const SLEUTEL_GESLOTEN_OP = 'aurea_kh_gesloten_op';
  const bewaar = (sleutel, waarde) => {
    try {
      window.localStorage.setItem(sleutel, waarde);
    } catch (e) {
      /* opslag geblokkeerd: de popup werkt verder gewoon */
    }
  };

  const venster = root.querySelector('.aurea-kh__venster');
  const stappen = [...root.querySelectorAll('[data-kh-stap]')];
  const vragen = stappen.filter((stap) => stap.dataset.khStap === 'vraag');
  const uitslagStap = stappen.find((stap) => stap.dataset.khStap === 'uitslag');
  const balk = root.querySelector('[data-kh-balk]');
  const balkRol = root.querySelector('[role="progressbar"]');

  /* Productdata uit de snippet */
  const modellen = {};
  root.querySelectorAll('[data-kh-data] [data-kh-model]').forEach((blok) => {
    const kleuren = {};
    blok.querySelectorAll('[data-kh-kleur]').forEach((span) => {
      kleuren[span.dataset.khKleur] = {
        variant: span.dataset.khVariant,
        foto: span.dataset.khFoto,
        fotoGroot: span.dataset.khFotoGroot,
      };
    });
    modellen[blok.dataset.khModel] = { titel: blok.dataset.khTitel, url: blok.dataset.khUrl, kleuren };
  });

  let antwoorden = {};
  let geschiedenis = [];
  let huidig = null;
  let vorigeFocus = null;

  const zichtbareVragen = () =>
    vragen.filter((vraag) => {
      if (vraag.dataset.khVraag !== 'strava') return true;
      return antwoorden.route === 'Ja' || antwoorden.route === 'Soms';
    });

  const zetBalk = (procent) => {
    balk.style.width = `${procent}%`;
    balkRol.setAttribute('aria-valuenow', String(procent));
  };

  const toon = (stap) => {
    huidig = stap;
    stappen.forEach((s) => {
      s.hidden = s !== stap;
      s.classList.toggle('is-nieuw', s === stap);
    });
    const lijst = zichtbareVragen();
    if (stap.dataset.khStap === 'start') zetBalk(0);
    else if (stap.dataset.khStap === 'uitslag') zetBalk(100);
    else zetBalk(Math.round((lijst.indexOf(stap) / lijst.length) * 100));
    const titel = stap.querySelector('.aurea-kh__titel');
    if (titel) venster.setAttribute('aria-label', titel.textContent.trim());
    venster.scrollTop = 0;
  };

  const herstelVraag = (vraag) => {
    vraag.querySelectorAll('[data-kh-optie]').forEach((knop) => {
      knop.classList.remove('is-gekozen');
      if (knop.hasAttribute('aria-pressed')) knop.setAttribute('aria-pressed', 'false');
    });
    const verder = vraag.querySelector('[data-kh-verder]');
    if (verder) verder.disabled = true;
  };

  const volgende = () => {
    const lijst = zichtbareVragen();
    const index = lijst.indexOf(huidig);
    if (huidig.dataset.khStap === 'start') {
      toon(lijst[0]);
      return;
    }
    if (index < lijst.length - 1) {
      toon(lijst[index + 1]);
      return;
    }
    vulUitslag();
    toon(uitslagStap);
  };

  const terug = () => {
    const vorige = geschiedenis.pop();
    if (!vorige) return;
    delete antwoorden[huidig.dataset.khVraag];
    herstelVraag(huidig);
    toon(vorige);
  };

  const open = () => {
    if (!root.hidden) return;
    vorigeFocus = document.activeElement;
    antwoorden = {};
    geschiedenis = [];
    vragen.forEach(herstelVraag);
    root.hidden = false;
    // Eerst tonen, dan de overgang starten.
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
    toon(stappen[0]);
    venster.focus({ preventScroll: true });
    document.addEventListener('keydown', opToets);
  };

  const sluit = () => {
    root.classList.remove('is-open');
    root.hidden = true;
    document.removeEventListener('keydown', opToets);
    bewaar(SLEUTEL_GESLOTEN_OP, String(Date.now()));
    document.dispatchEvent(new CustomEvent('aurea:keuzehulp-gesloten'));
    if (vorigeFocus && vorigeFocus.focus) vorigeFocus.focus({ preventScroll: true });
  };

  const opToets = (event) => {
    if (event.key === 'Escape') {
      sluit();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusbaar = [...venster.querySelectorAll('button, a[href]')].filter(
      (el) => el.offsetParent !== null && !el.disabled
    );
    if (!focusbaar.length) return;
    const eerste = focusbaar[0];
    const laatste = focusbaar[focusbaar.length - 1];
    if (event.shiftKey && (document.activeElement === eerste || document.activeElement === venster)) {
      event.preventDefault();
      laatste.focus();
    } else if (!event.shiftKey && document.activeElement === laatste) {
      event.preventDefault();
      eerste.focus();
    }
  };

  root.addEventListener('click', (event) => {
    const doel = event.target.closest('[data-kh-sluit], [data-kh-verder], [data-kh-terug], [data-kh-optie]');
    if (!doel) return;

    if (doel.hasAttribute('data-kh-sluit')) {
      sluit();
      return;
    }
    if (doel.hasAttribute('data-kh-terug')) {
      terug();
      return;
    }
    if (doel.hasAttribute('data-kh-verder')) {
      if (huidig.dataset.khStap === 'vraag') geschiedenis.push(huidig);
      volgende();
      return;
    }

    const vraag = doel.closest('[data-kh-vraag]');
    if (!vraag) return;

    if (vraag.hasAttribute('data-kh-multi')) {
      const aan = doel.getAttribute('aria-pressed') !== 'true';
      doel.setAttribute('aria-pressed', aan ? 'true' : 'false');
      const gekozen = [...vraag.querySelectorAll('[aria-pressed="true"]')].map((knop) => knop.dataset.khOptie);
      antwoorden[vraag.dataset.khVraag] = gekozen;
      vraag.querySelector('[data-kh-verder]').disabled = gekozen.length === 0;
      return;
    }

    antwoorden[vraag.dataset.khVraag] = doel.dataset.khOptie;
    vraag.querySelectorAll('[data-kh-optie]').forEach((knop) => knop.classList.toggle('is-gekozen', knop === doel));
    geschiedenis.push(vraag);
    window.setTimeout(volgende, 220);
  });

  /* Uitslag */

  const ZIN = {
    gps: 'De GPS zit in het horloge zelf. Je route loopt mee, ook als je telefoon thuis ligt.',
    strava: 'Na afloop staat je route in Strava.',
    kompas: 'Met kompas, barometer en zaklamp.',
    champagne: 'De kleur champagne heb je alleen bij de Auréa 2.',
    scherm: 'Het scherm kan altijd aan, zo ziet hij eruit als een gewoon horloge.',
    spatwater: 'Spatwaterdicht, dus weer of geen weer.',
    pols: 'Rond en fijn, gemaakt voor een smalle pols.',
    verfijnd: 'Rond en verfijnd, en hij zit de hele dag comfortabel.',
    bestseller: 'Onze bestseller.',
    sereaVierkant: 'Vierkant, met het grootste scherm van de drie.',
    sereaBerichten: 'Je berichten lees je groot en duidelijk.',
    extraGpsRond: 'De GPS zit alleen in de ronde Auréa 2.',
    extraAurea2Kleur: 'De Auréa 2 is er in goud en champagne.',
    extraSereaKleur: 'De Seréa is er in goud, zilver en zwart.',
  };

  const gpsWens = (a) => {
    const functies = a.functies || [];
    if (a.route === 'Ja' || a.strava === 'Ja') return true;
    return a.route === 'Soms' && functies.includes('Mijn route bijhouden');
  };

  const bepaalModel = (a) => {
    if (gpsWens(a)) return 'aurea2';
    if (a.look === 'Vierkant en modern') return 'serea';
    if (a.kleur === 'Champagne') return 'aurea2';

    const rond = a.look === 'Rond en klassiek';
    const punten = { aurea: 0, serea: 0, aurea2: 0 };
    if (a.pols === 'Smal') punten.aurea += 3;
    if (!rond && a.pols === 'Breed') punten.serea += 3;
    if (a.gebruik === 'Vooral voor mijn stijl') {
      punten.aurea += 1;
      if (!rond) punten.serea += 1;
    }
    if (a.gebruik === 'Vooral voor sport') punten.aurea2 += 2;
    if (a.gebruik === 'Allebei') punten.aurea2 += 1;

    const kandidaten = (rond ? ['aurea', 'aurea2'] : ['aurea', 'serea', 'aurea2']).filter(
      (model) => !(model === 'aurea2' && (a.kleur === 'Zilver' || a.kleur === 'Zwart'))
    );
    // Gelijkspel: de volgorde in de lijst beslist (Auréa, dan Seréa, dan Auréa 2).
    return kandidaten.reduce((beste, model) => (punten[model] > punten[beste] ? model : beste), kandidaten[0]);
  };

  const bepaalKleur = (model, a) => (modellen[model] && modellen[model].kleuren[a.kleur] ? a.kleur : 'Goud');

  const bepaalRedenen = (model, a) => {
    const functies = a.functies || [];
    const altijdAan = functies.includes('Altijd de tijd in beeld');
    if (model === 'serea') return [ZIN.sereaVierkant, ZIN.sereaBerichten];
    if (model === 'aurea') {
      const redenen = [a.pols === 'Smal' ? ZIN.pols : ZIN.verfijnd];
      if (altijdAan) redenen.push(ZIN.scherm);
      redenen.push(ZIN.bestseller);
      return redenen.slice(0, 3);
    }
    const gps = gpsWens(a);
    const redenen = [];
    if (gps) redenen.push(ZIN.gps);
    if (a.strava === 'Ja') redenen.push(ZIN.strava);
    if (gps || a.gebruik === 'Vooral voor sport') redenen.push(ZIN.kompas);
    if (a.kleur === 'Champagne') redenen.push(ZIN.champagne);
    if (altijdAan) redenen.push(ZIN.scherm);
    // Minimaal twee redenen, geen dubbele zinnen.
    [ZIN.spatwater, ZIN.scherm].forEach((zin) => {
      if (redenen.length < 2 && !redenen.includes(zin)) redenen.push(zin);
    });
    return redenen.slice(0, 3);
  };

  const bepaalExtra = (model, a) => {
    const extra = [];
    if (model === 'aurea2' && a.look === 'Vierkant en modern') extra.push(ZIN.extraGpsRond);
    if (model === 'aurea2' && (a.kleur === 'Zilver' || a.kleur === 'Zwart')) extra.push(ZIN.extraAurea2Kleur);
    if (model === 'serea' && a.kleur === 'Champagne') extra.push(ZIN.extraSereaKleur);
    return extra;
  };

  const bereken = (a) => {
    const model = bepaalModel(a);
    return { model, kleur: bepaalKleur(model, a), redenen: bepaalRedenen(model, a), extra: bepaalExtra(model, a) };
  };
  root.aureaKhBereken = bereken;

  const vulUitslag = () => {
    const uitslag = bereken(antwoorden);
    const model = modellen[uitslag.model];
    if (!model) return;
    const kleur = uitslag.kleur;
    const variant = model.kleuren[kleur] || Object.values(model.kleuren)[0];

    uitslagStap.querySelectorAll('[data-kh-uitslag-naam]').forEach((el) => {
      el.textContent = model.titel;
    });
    const foto = uitslagStap.querySelector('[data-kh-uitslag-foto]');
    foto.src = variant.foto;
    foto.srcset = `${variant.foto} 640w, ${variant.fotoGroot} 960w`;
    foto.sizes = '220px';
    foto.alt = `${model.titel} ${kleur}`;

    const lijst = uitslagStap.querySelector('[data-kh-uitslag-redenen]');
    lijst.textContent = '';
    uitslag.redenen.forEach((zin) => {
      const li = document.createElement('li');
      li.textContent = zin;
      lijst.appendChild(li);
    });

    const extraBlok = uitslagStap.querySelector('[data-kh-uitslag-extra]');
    extraBlok.textContent = '';
    uitslag.extra.forEach((zin) => {
      const p = document.createElement('p');
      p.className = 'aurea-kh__tekst aurea-kh__kleurzin';
      p.textContent = zin;
      extraBlok.appendChild(p);
    });
    extraBlok.hidden = uitslag.extra.length === 0;

    uitslagStap.querySelector('[data-kh-uitslag-link]').href = `${model.url}?variant=${variant.variant}`;
    root.dataset.khUitslag = `${uitslag.model}|${kleur}`;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href$="#keuzehulp"]');
    if (!link) return;
    event.preventDefault();
    open();
  });

  if (new URLSearchParams(window.location.search).get('keuzehulp') === '1') open();
})();
